export enum ROUTES {
  HOME = 'HOME',
  YEP = 'YEP',
  ABOUT = 'ABOUT',
  DOWNLOAD = 'DOWNLOAD',
  BABYSITTING = 'BABYSITTING',
  HOMEWORK = 'HOMEWORK',
  GARDENING = 'GARDENING',
  DOGMINDING = 'DOGMINDING',
  EVENT = 'EVENT',
}

export const ROUTE_MAP = {
  sv: {
    HOME: '/',
    YEP: '/ungdomar/jag-vill-jobba',
    ABOUT: '/foretaget/om-oss',
    DOWNLOAD: '/ladda-ner-appen',
    BABYSITTING: '/bestallare/barnvakt',
    HOMEWORK: '/bestallare/laxhjalp',
    GARDENING: '/bestallare/tradgard',
    DOGMINDING: '/bestallare/hundvakt',
    EVENT: '/bestallare/eventhjalp',
  },
  en: {
    HOME: '/',
    YEP: '/youth/i-want-to-work',
    ABOUT: '/company/about-us',
    DOWNLOAD: '/download',
    BABYSITTING: '/customer/babysitting',
    HOMEWORK: '/customer/homework',
    GARDENING: '/customer/gardening',
    DOGMINDING: '/customer/dog-minding',
    EVENT: '/customer/event',
  },
};
